import type { AIPlatform } from "@p0security/shared/types/ai-inventory";
import { Handle, type NodeProps, Position } from "@xyflow/react";
import { memo } from "react";
import { color, font, radius } from "theme/aiInventory";

import { PlatformIcon } from "../../platforms/PlatformIcon.tsx";

export type AgentNodeData = {
  label: string;
  agentId: string;
  platform: AIPlatform;
};

const container: React.CSSProperties = {
  background: color.card,
  color: color.ink,
  border: `1px solid ${color.rule}`,
  borderRadius: radius.card,
  padding: "8px 12px",
  fontFamily: font.sans,
  fontSize: 12,
  fontWeight: 500,
  minWidth: 140,
  textAlign: "left",
  display: "flex",
  alignItems: "center",
  gap: 10,
};

const kicker: React.CSSProperties = {
  fontFamily: font.mono,
  fontSize: 9,
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: color.inkMute,
  marginBottom: 1,
};

export const AgentNode: React.FC<NodeProps> = memo(({ data }) => {
  const typed = data as AgentNodeData;
  return (
    <div style={container}>
      <Handle type="target" position={Position.Left} />
      <span
        aria-hidden
        style={{
          width: 24,
          height: 24,
          borderRadius: "50%",
          background: color.mute,
          color: color.ink,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          overflow: "hidden",
        }}
      >
        <PlatformIcon platform={typed.platform} size={14} />
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={kicker}>Agent</div>
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {typed.label}
        </div>
      </div>
      <Handle type="source" position={Position.Right} />
    </div>
  );
});
AgentNode.displayName = "AgentNode";
